import React, { useEffect, useState } from "react";
import logo from "../../assets/Frame 411.png";
import { Link, useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import AssociateModal from "../common/Associatemodal";
import InquiryModal from "../common/Inquirymodal";  

const MiddleNavBar = () => {
  const navigate = useNavigate();
  const [services, setServices] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [inquiryModalOpen, setInquiryModalOpen] = useState(false);
  const [associateModalOpen, setAssociateModalOpen] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000 });
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/services/get-all-services`);
      setServices(res.data || []);
    } catch (error) {
      console.error("Error fetching services:", error);
    }
  };

  const navLinks = [
    { label: "Home", path: "/" },
    { label: "About", path: "/about" },
    { label: "Contact", path: "/contact" },
    { label: "Our Services", path: "/our-service" },
    { label: "Blog", path: "/blog-list" },
    { label: "Articles", path: "/all-article" },
    { label: "Be Associate", type: "modal", onClick: () => setAssociateModalOpen(true) },
  ];

  return (
    <>
      <div className="flex justify-between items-center px-10 bg-white py-1 overflow-hidden">
        {/* Left: Logo + Brand Name */}
        <div className="md:flex items-center hidden">
          <Link to="/">
            <img
              data-aos="zoom-in-left"
              src={logo}
              alt="LOGO"
              className="h-auto w-[5rem] cursor-pointer"
            />
          </Link>

          <span
            data-aos="zoom-in-right"
            className="text-2xl md:text-3xl lg:text-4xl tracking-wider hidden md:flex gap-3 font-extrabold ml-2"
          >
            <span className="text-[#101828]">BBSR</span>
            <span className="text-[#FFAC26]">SERVICES</span>
          </span>
        </div>

        {/* Middle: Auto Sliding Services */}
        {/* <div className="hidden overflow-hidden relative h-[40px] md:flex items-center justify-end">
          <div className="whitespace-nowrap animate-slides text-[#72a7c3] font-semibold w-80 cursor-pointer text-sm sm:text-base">
            {services.length > 0 ? (
              services.map((service, index) => (
                <span
                  key={index}
                  className="inline-block mx-6 hover:text-[#FFAC26] transition-all duration-300"
                  onClick={() => navigate(`/service-details/${service._id}`)}
                >
                  {service.serviceName}
                </span>
              ))
            ) : (
              <span className="text-gray-500">Loading services...</span>
            )}
          </div>
        </div> */}

        {/* Right: Buttons + Hamburger */}
        <div
          data-aos="fade-down"
          data-aos-easing="linear"
          data-aos-duration="1500"
          className="hidden md:flex gap-4 items-center"
        >
          <button
            onClick={() => setInquiryModalOpen(true)}
            className="bg-[#2F9BD6] rounded-full w-32 py-2 text-white font-semibold hover:bg-[#218ac0] transition"
          >
            Inquiry Now
          </button>
          <button
            onClick={() => navigate("/login")}
            className="bg-[#FFAC26] text-white rounded-full w-32 py-2 font-semibold hover:bg-[#e89b10] transition"
          >
            Log In
          </button>

          {/* Hamburger Button */}
          <button
            onClick={() => setSidebarOpen(true)}
            className="flex flex-col justify-center items-center gap-[5px] w-10 h-10 rounded-lg hover:bg-gray-100 transition"
            aria-label="Open menu"
          >
            <span className="block w-6 h-[2px] bg-[#101828] rounded"></span>
            <span className="block w-6 h-[2px] bg-[#101828] rounded"></span>
            <span className="block w-6 h-[2px] bg-[#101828] rounded"></span>
          </button>
        </div>
      </div>

      {/* Sidebar Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 z-40"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar Drawer */}
      <div
        className={`fixed top-0 right-0 h-full w-72 bg-white z-[9999] shadow-2xl transform transition-transform duration-300 ${
          sidebarOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        {/* Sidebar Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b border-gray-100">
          <span className="text-xl font-extrabold">
            <span className="text-[#101828]">BBSR</span>{" "}
            <span className="text-[#FFAC26]">SERVICES</span>
          </span>
          <button
            onClick={() => setSidebarOpen(false)}
            className="text-gray-500 hover:text-[#101828] transition text-2xl leading-none"
            aria-label="Close menu"
          >
            &times;
          </button>
        </div>

        {/* Sidebar Nav Links */}
        <nav className="flex flex-col px-6 py-6 gap-2">
          {navLinks.map((link, index) =>
            link.type === "modal" ? (
              <button
                key={index}
                onClick={() => {
                  setSidebarOpen(false);
                  link.onClick();
                }}
                className="text-left text-[#101828] font-semibold text-base py-3 px-4 rounded-lg hover:bg-[#FFF7E6] hover:text-[#FFAC26] transition-all duration-200 border-b border-gray-50"
              >
                {link.label}
              </button>
            ) : (
              <Link
                key={index}
                to={link.path}
                onClick={() => setSidebarOpen(false)}
                className="text-[#101828] font-semibold text-base py-3 px-4 rounded-lg hover:bg-[#FFF7E6] hover:text-[#FFAC26] transition-all duration-200 border-b border-gray-50"
              >
                {link.label}
              </Link>
            )
          )}
        </nav>
      </div>

      {/* Inquiry Modal */}
      <InquiryModal
        isOpen={inquiryModalOpen}
        onClose={() => setInquiryModalOpen(false)}
        services={services}
      />

      {/* Be Associate Modal */}
      <AssociateModal
        isOpen={associateModalOpen}
        onClose={() => setAssociateModalOpen(false)}
      />
    </>
  );
};

export default MiddleNavBar;